import { render, staticRenderFns } from "./SectionHeaderDoubleButtonCancel.vue?vue&type=template&id=2b33cdcd&scoped=true"
import script from "./SectionHeaderDoubleButtonCancel.vue?vue&type=script&lang=js"
export * from "./SectionHeaderDoubleButtonCancel.vue?vue&type=script&lang=js"
import style0 from "./SectionHeaderDoubleButtonCancel.vue?vue&type=style&index=0&id=2b33cdcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b33cdcd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VBtn,VCol,VIcon})
